export const analysisState = {
  computing: 'computing',
  fresh: 'fresh',
  empty: 'empty',
  error: 'error',
}

export const errorState = { state: analysisState.error, websocket_url: null, payload: null }
